// removed by extract-text-webpack-plugin
module.exports = {"Tab":"Tab__Tab__2uexl","Active":"Tab__Active__3_wzd"};